import { useCallback, useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { Translation } from 'components/Translations/Translation'
import styles from './tooltip.module.scss'

type Props = {
	content: string // TODO: content moze biti string | number | React.ReactElement (formatter iz models.ts) pa bi valjalo implementirati tako i tooltip
	targetRef: React.MutableRefObject<HTMLDivElement | null>
	withTranslation?: boolean
}

export const Tooltip = ({ content, targetRef, withTranslation = false }: Props) => {
	const tooltipRef = useRef<HTMLDivElement>(null);
	const [style, setStyle] = useState<React.CSSProperties>();

	const calculatePositionStyle = useCallback(
		(e: MouseEvent) => {
			const tooltip = tooltipRef.current;
			if (!tooltip) {
				return;
			}

			const { width: tooltipWidth, height: tooltipHeight } = tooltip.getBoundingClientRect();

			const tooltipX = e.clientX + 12;
			const tooltipY = e.clientY + 12;

			const screenWidth = window.innerWidth;
			const screenHeight = window.innerHeight;

			let adjustedX = tooltipX;
			let adjustedY = tooltipY;

			// Adjust position if tooltip overflow right
			if (tooltipX + tooltipWidth > screenWidth) {
				adjustedX = tooltipX - tooltipWidth - 24;
			}
			// Adjust position if tooltip overflow bottom
			if (tooltipY + tooltipHeight > screenHeight) {
				adjustedY = screenHeight - tooltipHeight - 12;
			}

			const tooltipStyle: React.CSSProperties = {
				position: 'fixed',
				top: `${adjustedY}px`,
				left: `${adjustedX}px`,
			};

			setStyle(tooltipStyle);
		},
		[]
	)

	useLayoutEffect(
		() => {
			const target = targetRef.current;
			if (!target) {
				return;
			}

			target.addEventListener('mouseenter', calculatePositionStyle);

			return () => {
				target.removeEventListener('mouseenter', calculatePositionStyle);
			}
		},
		[calculatePositionStyle, targetRef]
	)

	const component = (
		<div ref={tooltipRef} className={styles.content} style={style}>
			{withTranslation ? <Translation i18n={content} /> : content}
		</div>
	)

	return createPortal(component, document.body);
}
